import i18n from 'constants/translation/i18n';

const auditFindingsWorkflow = (t?: any) => {
  const entries = [
    {
      area: 'audit_findings_management',
      title: t
        ? t('AUDIT_FINDINGS_MANAGEMENT')
        : i18n.t('AUDIT_FINDINGS_MANAGEMENT'),
      href: '/dataManagement/auditFindings'
    },
    {
      area: 'allocation_of_audit_findings',
      title: t ? t('AUDIT_FINDINGS_MAPPING') : i18n.t('AUDIT_FINDINGS_MAPPING'),
      href: '/audit_findings_table'
    }
  ];
  return entries;
};

export default auditFindingsWorkflow;
